import type { CostsWithVehicle } from '@cobliteam/common-types';
import { currencyFormatter, numberFormatter } from '@cobliteam/maintenance/src/components/utils';
import CameraIdentifier from '@cobliteam/media/src/components/CameraIdentifier';
import DataTable, { DataTableCellVehicle } from '@cobliteam/ui-business/components/DataTable';
import type { ColumnDef } from '@tanstack/react-table';
import CostDetailModalModule from './CostDetailModal';

const columnsDef: ColumnDef<CostsWithVehicle>[] = [
  {
    id: 'vehicleId',
    accessorKey: 'vehicleId',
    accessorFn: (row) =>
      `${row.vehicle?.licensePlate} - ${row.vehicle?.model.brand} - ${row.vehicle?.model.name} ${row.vehicle?.groups ? row.vehicle?.groups[0]?.name : '--'} ${row.vehicle?.alias ?? ''}`,
    header: DataTable.Header,
    cell: ({ row }) => (
      <div className='flex items-center gap-3'>
        {row.original.withDashCam ? <CameraIdentifier hasCta={false} /> : <div className='w-6' />}
        <DataTableCellVehicle
          brand={row.original.vehicle?.model.brand}
          model={row.original.vehicle?.model.name}
          licensePlate={row.original.vehicle?.licensePlate}
          groupName={row.original.vehicle?.groups ? row.original.vehicle?.groups[0]?.name : '--'}
        />
      </div>
    ),
    meta: {
      name: 'Placa e Modelo',
    },
  },
  {
    id: 'drivenDistanceInMeters',
    accessorFn: (row) => row.drivenDistanceInMeters / 1000,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={`${numberFormatter.format(Number((row.original.drivenDistanceInMeters / 1000).toFixed(1)))} Km`} />,
    meta: {
      name: 'Distância',
    },
  },
  {
    id: 'fuelCost',
    accessorKey: 'fuelCost',
    accessorFn: (row) => row.fuelCost,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={`R$ ${currencyFormatter.format(row.original.fuelCost)}`} />,
    meta: {
      name: 'Combustível',
    },
  },
  {
    id: 'maintenanceCost',
    accessorKey: 'maintenanceCost',
    accessorFn: (row) => row.maintenanceCost,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={`R$ ${currencyFormatter.format(row.original.maintenanceCost)}`} />,
    meta: {
      name: 'Manutenção',
    },
  },
  {
    id: 'totalCost',
    accessorKey: 'totalCost',
    accessorFn: (row) => row.fuelCost + row.maintenanceCost,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={`R$ ${currencyFormatter.format(row.original.fuelCost + row.original.maintenanceCost)}`} />,
    meta: {
      name: 'Total',
    },
  },
  {
    id: 'actions',
    header: DataTable.Header,
    cell: ({ row }) => (
      <DataTable.Actions>
        <CostDetailModalModule row={row} />
      </DataTable.Actions>
    ),
    meta: {
      name: 'Ações',
      alignHeader: 'center',
    },
  },
];

export default columnsDef;
